<template>
	<div class="product-stock">
		<div class="modal-body">

		<template v-if="productstocklist.length > 0" >
			<div class="form-inline pb-2" v-for="(productstock,index) in productstocklist" :key="'stock_'+ index" style="padding-bottom:5px;">
				<a href="javascript:void(0);" @click="deleteProductStock(index, productstock.id)"><i class="fa fa-trash middle"></i></a>			
				<input type="text" maxlength="255" class="form-control" id="optionInput" name="options[]" data-vv-as="Options" v-validate="'required'" placeholder="Option" v-model="productstock.option" style="width:100px;display:inline-block">
				<a href="javascript:void(0);" class="btn btn-default btn-xs btn-none-radius" style="padding: 4px 5px 1px 5px;font-size: 10px;" @click="removeCount(index)" :disabled="productstock.quantity == min">
					<span class="glyphicon glyphicon-minus" ></span>
				</a>
				 <input type="text" maxlength="3" pattern="[0-9]*" inputmode="numeric" name="quantity[]" data-vv-as="Quantity" v-validate="'required|numeric|max_value:999|min_value:0'" class="form-control" id="quantityInput" placeholder="Quantity" v-model="productstock.quantity" style="width: 55px;display:inline-block;margin-left:5px;margin-right:5px;text-align:center">
				<a href="javascript:void(0);" class="btn btn-default btn-xs btn-none-radius" style="padding: 4px 5px 1px 5px;font-size: 10px;" @click="addCount(index)" :disabled="productstock.quantity == max">
					<span class="glyphicon glyphicon-plus"></span>
				</a>
			</div>
			<div :class="{'has-error': errors.has('options[]') || errors.has('quantity[]')}">
				<p class="text-error" v-show="errors.has('options[]')">{{ errors.first('options[]') }}</p>
				<p class="text-error" v-show="errors.has('quantity[]')">{{ errors.first('quantity[]') }}</p>
			</div>
		</template>
		<template v-else>
			<div class="alert alert-secondary" role="alert">
				No stock
			</div>
		</template>

		<a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" @click="addProductStock"><span class="glyphicon glyphicon-plus"></span> Add More</a>

		<add-stock class="form-inline pb-2" style="padding-bottom:5px;" v-if="isAdd" :max="max" :min="min" @onAddStock="addProductStock" @onDeleteStock="isAdd = false"></add-stock>

		</div>

		<div class="modal-footer">
			<button type="button" class="btn btn-primary" @click="editProductStock">Save</button>
			<button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Close</button>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import AddStock from './AddStock'

export default{
	props:['value'],
	data: function(){
		return {
			product: this.value,
			productstocklist : [],
			newProductStock: {
				option: null,
				quantity: 0
			},
			min: 0,
			max: 999,
			isAdd: false,
			deletelist: []
		}
	},
	mounted: function(){	
		this.getProductStock()
	},
	components: {
		AddStock,
	},
	methods: {
		getProductStock: function(){
			let vm = this
			vm.productstocklist = []
			if (!vm.product.id) {
				return false;
			}
			// vm.$store.dispatch('loading')
			api.getProductStock(vm.product.id,function(error, response){
				if (error) {
					console.error(error)
				}
				vm.productstocklist = response.productstocklist
				// vm.$store.dispatch('loading')
			})
		},
		addProductStock: function(){
			let vm = this
			vm.productstocklist.push({
				id: null,
				option: null,
				quantity: 1
			})

		},
		editProductStock: function(){
			let vm = this
			vm.$validator.validate().then(result => {
				if (!result) {
					// do stuff if not valid.
					vm.goToErrorInput()
					return false
				}
			vm.$store.dispatch('loading')

			let productstock = []
			$.each(vm.productstocklist, function(index, value){
				let stock = {
					id: value.id,
					option: value.option, 
					productid: value.productid, 
					quantity: value.quantity, 
				}
				if (value.id == null) {
					stock.productid = vm.product.id
					api.saveProductStock(stock,function(error, response){
						if (error) {
							console.error(error)
						}
						stock.id = response.productstockid
					})
				} else {
					api.editProductStock(stock,function(error, response){
						if (error) {
							console.error(error)
						}
					})
				}

				productstock.push([stock.id,stock.option,stock.quantity])
			})

			$.each(vm.deletelist,function(index,val){
				api.deleteProductStock(val,function(error, response){
					if (error) {
						console.error(error)
					}
				})
			})

			vm.product.productstock = productstock	
			vm.$emit('input',vm.product)
			vm.$emit('saveStock')
			vm.$store.dispatch('loading')
			})
		},
		deleteProductStock: function(index, id){
			let vm = this
			
			if (vm.productstocklist.length <= 1) {
				alert("The stock must have at least 1")
				return false;
			}
			if (confirm('Do you want to delete this?')) {
				if (id != null) {
					vm.deletelist.push(id)
				} 
				vm.productstocklist.splice(index,1)
			}
		},
		removeCount: function(index){
			if (this.productstocklist[index].quantity > this.min) {
				this.productstocklist[index].quantity = parseInt(this.productstocklist[index].quantity) - 1
			}
		},
		addCount: function(index){
			if (this.productstocklist[index].quantity < this.max) {
				this.productstocklist[index].quantity = parseInt(this.productstocklist[index].quantity) + 1
			}
		},
	},
	watch: {
		'value': function(newVal , oldVal){
			this.product = this.value
		},
		'value.productstock': function(newVal , oldVal){
			this.getProductStock()

		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/template/event/ProductStock.vue